import { render, staticRenderFns } from "./ExpandableMainNavItem.vue?vue&type=template&id=3f157490&"
import script from "./ExpandableMainNavItem.vue?vue&type=script&lang=js&"
export * from "./ExpandableMainNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports